import { jsx as _jsx } from "react/jsx-runtime";
import { InCallNotes, Spinner, SpinnerWrapper } from '@streem/ui-react';
import { recordElementClicked } from '@streem/analytics';
import { useSpectatorNotes } from '../../../hooks/use_spectator_notes';
export function SpectatorNotes() {
    const { defaultTemplate, onSave, currentlySavedMarkdown, onNoteUpdated, maxCharacters, currentInputText, loadedYn, } = useSpectatorNotes();
    if (!loadedYn) {
        return (_jsx(SpinnerWrapper, { height: "19.625rem", "data-testid": "spectator-note-spinner-wrapper", children: _jsx(Spinner, { size: "2rem" }) }));
    }
    return (_jsx(InCallNotes, { defaultTemplate: defaultTemplate, onSave: onSave, markdownPersistedToBackend: currentlySavedMarkdown, onNoteUpdated: onNoteUpdated, maxCharacters: maxCharacters, captureButtonClick: recordElementClicked, initialMarkdown: currentInputText }));
}
//# sourceMappingURL=spectator_notes.js.map